import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, PLATFORM_ID, computed, inject, signal } from '@angular/core';
import { Observable, Subscription, catchError, of, switchMap, tap, timer } from 'rxjs'; // <-- Aggiunti catchError e of
import { environment } from '../../environments/environment';
import { DocumentItem, FileRecord, IngestionDto, IngestionResponse, Task, TaskStatusResponse } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private readonly filesApiUrl = `${environment.apiUrl}/files`;
  private readonly documentsApiUrl = `${environment.apiUrl}/documents`;
  private readonly http = inject(HttpClient);

  // Metodo per recuperare la lista
  getDocuments(status: string): Observable<DocumentItem[]> {
    return this.http.get<DocumentItem[]>(`${this.filesApiUrl}/${status}`);
  }

  ingestDocuments(task: string, body: IngestionDto): Observable<IngestionResponse> {
    return this.http.post<IngestionResponse>(`${this.documentsApiUrl}/${task}`, body);
  }

  uploadSingleFile(file: File, path: string) {
    const params = new HttpParams().set('path', path);
    
    // Chiede il signed URL al backend passando il path
    return this.http.get<{ url: string }>(`${this.filesApiUrl}/presigned-upload-url`, { params }).pipe(
      switchMap((response) => {
        // PUT direttamente sul bucket S3 usando il signed URL
        return this.http.put(response.url, file, {
          headers: { 
            'Content-Type': file.type || 'application/octet-stream' 
          }
        });
      })
    );
  }

   // Metodo per recuperare il dettaglio del singolo documento
   getDocumentsDetail(id: string): Observable<FileRecord> {
    return this.http.get<FileRecord>(`${this.filesApiUrl}/${id}`);
  }
}
